import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoToFixComponent } from './info-to-fix.component';
import { DataModule } from '../../data/data.module';

@NgModule({
  declarations: [
    InfoToFixComponent
  ],
  imports: [
    CommonModule,
    DataModule
  ], exports:[
    InfoToFixComponent
  ]
})
export class InfoToFixModule { }
